/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PutSelectedEnvironmentsPathParams = NonNullable<
  operations['putSelectedEnvironments']['parameters']['path']
>;

export type PutSelectedEnvironmentsRequestBody = OperationRequestBodyContent<operations['putSelectedEnvironments']>;

export interface Input extends PutSelectedEnvironmentsPathParams {
  apiVersion?: string;
  body: PutSelectedEnvironmentsRequestBody;
}

export async function putSelectedEnvironments(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PUT('/internal/profile/selected-environments/{projectKey}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
